<script setup>
/**
 * "−10 ✦": the carats a lesson's draw took, for a moment by the card
 * (lesson-redo DESIGN.md E2.4; utils/pick-charge.js times it). Fixed at the
 * point it is given (the filled slot), it rises a little and fades. Nothing
 * under reduced motion.
 */
import CaratMark from '@/components/ui/CaratMark.vue'

defineProps({
  amount: { type: Number, required: true },
  x: { type: Number, default: 0 },
  y: { type: Number, default: 0 },
})
</script>

<template>
  <span class="pick-charge" data-testid="pick-charge" role="img" :aria-label="`${amount} carats`"
        :style="{ left: `${x}px`, top: `${y}px` }">
    <span aria-hidden="true">−{{ amount }}</span>
    <CaratMark :size="12" />
  </span>
</template>

<style scoped>
.pick-charge {
  position: fixed;
  z-index: 1200;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 9px;
  border-radius: 999px;
  border: 1px solid rgba(255, 223, 163, 0.45);
  background: rgba(26, 12, 46, 0.82);
  color: #f0d9a3;
  font: 600 13px/1 'Cinzel', Georgia, serif;
  letter-spacing: 0.04em;
  white-space: nowrap;
  pointer-events: none;
  transform: translate(-50%, -100%);
  animation: pick-charge-rise 1.5s ease-out both;
}
@keyframes pick-charge-rise {
  0% { opacity: 0; transform: translate(-50%, -80%); }
  18% { opacity: 1; transform: translate(-50%, -100%); }
  70% { opacity: 1; }
  100% { opacity: 0; transform: translate(-50%, -150%); }
}
@media (prefers-reduced-motion: reduce) {
  .pick-charge { display: none; }
}
</style>
